import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { makeStyles } from "tss-react/mui";
import GetAppIcon from "@mui/icons-material/GetApp";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../services/api";

const useStyles = makeStyles()((theme) => ({
	messageMedia: {
		objectFit: "cover",
		width: "100%",
		height: "auto",
		maxHeight: 300,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		cursor: "pointer",
		display: "block",
	},
	overlay: {
		position: "fixed",
		inset: 0,
		backgroundColor: "rgba(0,0,0,0.9)",
		zIndex: 1400,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "zoom-out",
	},
	header: {
		position: "fixed",
		top: 0,
		right: 0,
		padding: 8,
		display: "flex",
		gap: 4,
		zIndex: 1401,
	},
	iconBtn: {
		background: "none",
		border: "none",
		color: "#fff",
		cursor: "pointer",
		padding: 6,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		"&:hover": {
			backgroundColor: "rgba(255,255,255,0.15)",
		},
	},
	fullImage: {
		maxWidth: "90vw",
		maxHeight: "90vh",
		objectFit: "contain",
		cursor: "default",
	},
}));

const ModalImageCors = ({ imageUrl }) => {
	const { classes } = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!imageUrl) return;
		const fetchImage = async () => {
			const { data, headers } = await api.get(imageUrl, {
				responseType: "blob",
			});
			const url = window.URL.createObjectURL(
				new Blob([data], { type: headers["content-type"] })
			);
			setBlobUrl(url);
			setFetching(false);
		};
		fetchImage();
	}, [imageUrl]);

	const handleDownload = () => {
		const a = document.createElement("a");
		a.href = blobUrl || imageUrl;
		a.download = imageUrl.split("/").pop() || "download";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	return (
		<>
			<img
				className={classes.messageMedia}
				src={fetching ? imageUrl : blobUrl}
				alt="media"
				onClick={() => setOpen(true)}
			/>
			{open && ReactDOM.createPortal(
				<div className={classes.overlay} onClick={() => setOpen(false)}>
					<div
						className={classes.header}
						onClick={(e) => e.stopPropagation()}
					>
						<button
							className={classes.iconBtn}
							onClick={handleDownload}
							title="Download"
						>
							<GetAppIcon />
						</button>
						<button
							className={classes.iconBtn}
							onClick={() => setOpen(false)}
							title="Close"
						>
							<CloseIcon />
						</button>
					</div>
					<img
						className={classes.fullImage}
						src={blobUrl || imageUrl}
						alt="media"
						onClick={(e) => e.stopPropagation()}
					/>
				</div>,
				document.body
			)}
		</>
	);
};

export default ModalImageCors;
